var React = require('react');

function IconMobilePhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 4c0-2.206 1.794-4 4-4h14c2.206 0 4 1.794 4 4v24c0 2.206-1.794 4-4 4H4c-2.206 0-4-1.794-4-4V4Zm13 24c0-1.106-.894-2-2-2-1.106 0-2 .894-2 2 0 1.106.894 2 2 2 1.106 0 2-.894 2-2Zm5-24H4v20h14V4Z","fill":"currentColor"}));
}

IconMobilePhone.defaultProps = {"fill":"none","viewBox":"0 0 22 32"};

module.exports = IconMobilePhone;

IconMobilePhone.default = IconMobilePhone;
